
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.5","y":"1.375","width":"26","height":"27.25","rx":"13","fill":"#218665"}}),_c('path',{attrs:{"d":"M9.207 14.668a1 1 0 00-1.414 1.414l1.414-1.414zm3.043 4.457l-.707.707.707.707.707-.707-.707-.707zm8.957-7.543a1 1 0 00-1.414-1.414l1.414 1.414zm-13.414 4.5l3.75 3.75 1.414-1.414-3.75-3.75-1.414 1.414zm5.164 3.75l8.25-8.25-1.414-1.414-8.25 8.25 1.414 1.414z","fill":"#74DBB5"}}),_c('rect',{attrs:{"x":"1.5","y":"1.375","width":"26","height":"27.25","rx":"13","stroke":"#74DBB5","stroke-width":"2"}})])
          )
        }
      }
    